import { Pipe, PipeTransform } from '@angular/core';

/**
 * Creates fake array of items to iterate in the template to render empty blocks.
 * If currentItems is provided, it will return the difference between times and currentItems.
 */
@Pipe({ name: 'avsTimes' })
export class TimesPipe implements PipeTransform {
  transform(times = 0, currentItems?: number): number[] {
    if (currentItems === undefined) {
      return Array.from(Array(times));
    }

    if (times > currentItems) {
      return [];
    }

    return Array.from(Array(currentItems - times));
  }
}
